<style lang="scss">
.yi-region-input {
	.el-input {
		min-width: auto;
		flex: 1;
	}

	.el-input-number {
		min-width: auto;
		flex: 1;
	}
}
</style>

<template>
	<div v-if="type == 'numberrange'" class="yi-region-input" style="width: 195px;display: flex;">
		<el-input-number controls-position="right" :size="size" :min="min" :max="max" :disabled="disabled" placeholder="" v-model="num1" type="number" @change="change1" :precision="precision"></el-input-number>
		<div style="margin: 0 4px;">-</div>
		<el-input-number controls-position="right" :size="size" :min="min" :max="max" :disabled="disabled" placeholder="" v-model="num2" type="number" @change="change2" :precision="precision"></el-input-number>
	</div>
	<div v-else-if="type == 'number'">
		<el-input-number controls-position="right" :size="size" :min="min" :max="max" :disabled="disabled" placeholder="" v-model="num1" type="number" @change="change1" :precision="precision"></el-input-number>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'yi_number_input',
	props: {
		start: {
			type: Number,
			default: null,
		},
		end: {
			type: Number,
			default: null,
		},
		type: {
			type: String,
			default: 'number' //number,numberrange
		},

		convert: {
			type: String, //s-m,s-h
			default: "none",
		},
		disabled: {
			type: Boolean,
			default: false,

		},
		size: {
			type: String,
			default: "mini",
		},
		min: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			default: 9999999999,
		},
		precision: {
			type: Number,
			default: 0,
		},


	}, //v-model必须使用value关键字
	components: {},
	data() {
		return {
			ratios: {
				"none": 1,
				"s-m": 60.0,
				"s-h": 3600.0,
				"mm-cm": 10.0,
				"g-kg": 1000.0,
			},
			num1: null,
			num2: null
		}
	},
	watch: {
		// value(val) {
		// 	if (val!=null) {
		// 		this.num = this.math.divide(this.math.bignumber(val), this.math.bignumber(this.ratios[this.type]))
		// 			.toNumber()
		// 	} else {
		// 		this.num = null
		// 	}
		// },
		// num(val) {
		// 	if (val!=null) {
		// 		this.num = this.math.divide(this.math.bignumber(val), this.math.bignumber(this.ratios[this.type]))
		// 			.toNumber()
		// 	} else {
		// 		this.num = null
		// 	}
		// }
	},
	created() {
		this.initNumber()
	},
	mounted() {

	},
	watch: {
		start(n, o) {
			if (n != this.num1) {
				this.initNumber()
			}

		},
		end(n, o) {
			if (n != this.num2) {
				this.initNumber()
			}
			//this.initNumber()
			// if (n!=null) {
			// 	this.$emit('update:end', n); //必须使用input关键字，触发input事件
			// } else {
			// 	this.$emit('update:end', null); //必须使用input关键字，触发input事件
			// }
		}
	},
	methods: {

		initNumber() {
			if (this.readonly == null) {
				this.readonly = false
			}
			if (this.disabled == null) {
				this.disabled = false
			}
			if (this.start != null) {
				this.num1 = this.math.divide(this.math.bignumber(this.start), this.math.bignumber(this.ratios[this
					.convert]))
					.toNumber()
			} else {
				//this.num1 = null
				this.num1 = this.min
			}
			if (this.end != null) {
				this.num2 = this.math.divide(this.math.bignumber(this.end), this.math.bignumber(this.ratios[this
					.convert]))
					.toNumber()
			} else {
				//this.num2 = null
				this.num2 = this.min
			}
			this.change1(this.num1)
			this.change2(this.num2)
			// alert(this.num1)
			// this.$emit('update:start', this.num1);
			// this.$emit('update:end', this.num2);
		},

		change1(cur, old) {
			//要用!=null，因为0会影响
			if (cur != null) {
				let newCur = this.math.multiply(this.math.bignumber(cur), this.math.bignumber(this.ratios[this
					.convert]))
				if (newCur < this.min) {
					newCur = this.min
				}
				this.$emit('update:start', newCur.toNumber()); //必须使用input关键字，触发input事件

			} else {
				//this.num = null
				this.$emit('update:start', null); //必须使用input关键字，触发input事件
			}


		},
		change2(cur, old) {
			//要用!=null，因为0会影响
			if (cur != null) {
				let newCur = this.math.multiply(this.math.bignumber(cur), this.math.bignumber(this.ratios[this
					.convert]))
				if (newCur < this.min) {
					newCur = this.min
				}
				this.$emit('update:end', newCur.toNumber()); //必须使用input关键字，触发input事件

			} else {
				//this.num = null
				this.$emit('update:end', null); //必须使用input关键字，触发input事件
			}


		}


	}
}
</script>
